<template>
  <jet-form-section @submitted="updatePassword">
    <template #title>Update password</template>

    <template #description>
      Update your password below to enhance your account’s protection.
      <br />
      Keep your account secure by using a long, random password.
    </template>

    <template #form>
      <!-- Current -->
      <div class="flex w-full gap-8 my-8">
        <div class="flex-1">
          <jet-label for="current_password" value="Current password" />
          <jet-input
            data-cy="clinician-current-password"
            id="current_password"
            type="password"
            class="mt-1 block w-full"
            v-model="form.current_password"
            ref="current_password"
            autocomplete="current-password"
          />
          <jet-input-error :message="form.errors.current_password" class="mt-2" />
        </div>
        <div class="flex-1"></div>
      </div>

      <div class="flex w-full gap-8 mb-8">
        <!-- New -->
        <div class="flex-1">
          <jet-label for="password" value="New password" />
          <jet-input
            data-cy="clinician-new-password"
            id="password"
            type="password"
            class="mt-1 block w-full"
            v-model="form.password"
            ref="password"
            autocomplete="new-password"
            @input="checkPassword"
            @paste="checkPassword"
          />
          <jet-input-error :message="form.errors.password" class="mt-2" />
          <div v-show="passwordValidationFailed" class="block absolute text-xxs text-gray-500">
            <PasswordChecklist
              class="mt-4"
              v-if="showPasswordChecklist"
              :password="form.password"
              @validated="validated"
            ></PasswordChecklist>
          </div>
        </div>

        <!-- Confirm -->
        <div class="flex-1">
          <jet-label for="password_confirmation" value="Confirm password" />
          <jet-input
            data-cy="clinician-confirm-password"
            id="password_confirmation"
            type="password"
            class="mt-1 block w-full"
            v-model="form.password_confirmation"
            autocomplete="new-password"
          />
          <jet-input-error :message="form.errors.password_confirmation" class="mt-2" />
        </div>
      </div>
    </template>

    <template #actions>
      <action-message
        :on="form.recentlySuccessful"
        message="Your password has been updated."
      ></action-message>
      <ViceButton
        data-cy="clinician-save-password-changes"
        :class="{
          'opacity-25': form.processing || passwordValidationFailed,
        }"
        class="px-4 border border-vice-light-grey"
        :disabled="form.processing || passwordValidationFailed"
        medium
      >
        Save
      </ViceButton>
    </template>
  </jet-form-section>
</template>

<script>
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetFormSection from '@/Jetstream/FormSection.vue';
import ActionMessage from '@/Jetstream/ActionMessage.vue';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import PasswordChecklist from '@/Components/PasswordChecklist.vue';

export default {
  components: {
    ViceButton,
    PasswordChecklist,
    ActionMessage,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
  },

  data() {
    return {
      form: this.$inertia.form({
        current_password: '',
        password: '',
        password_confirmation: '',
      }),
      passwordValidationFailed: false,
      showPasswordChecklist: false,
    };
  },

  methods: {
    updatePassword() {
      this.form.post(route('clinician-password.update'), {
        errorBag: 'updatePassword',
        preserveScroll: true,
        onSuccess: () => {
          this.form.reset();
          this.showPasswordChecklist = false;
        },
        onError: () => {
          this.showPasswordChecklist = false;

          if (this.form.errors.password) {
            this.form.reset('password', 'password_confirmation');
            this.$refs.password.focus();
          }

          if (this.form.errors.current_password) {
            this.form.reset('current_password');
            this.$refs.current_password.focus();
          }
        },
      });
    },

    checkPassword() {
      this.passwordValidationFailed = true;
      this.$emit('input', this.form.password);
      this.showPasswordChecklist = true;
    },

    validated(e) {
      this.passwordValidationFailed = e;
    },
  },
};
</script>
